import React from 'react';
import {useDispatch} from 'react-redux';

import * as flags from '../lib/flags';
import {useApi} from '../lib/api';
import {useUser} from '../lib/user';
import {updateNotificationCount} from '../state/actions';

const audio = new Audio('/assets/notification.mp3');

function NotificationWatcher() {
  const api = useApi();
  const user = useUser();
  const dispatch = useDispatch();
  const handle = React.useRef();
  const notificationCount = React.useRef(null);

  async function count() {
    try {
      const response = await api.countUnreadNotifications();

      if (notificationCount.current !== null && response.unread > notificationCount.current) {
        audio.play()
          .catch(e => console.warn('Unable to play notification sound', e));
      }

      notificationCount.current = response.unread;
      dispatch(updateNotificationCount(response.unread));
    }
    catch(e) {
      // Nothing to do, we'll just try again.
    }
    finally {
      handle.current = setTimeout(count, 5000);
    }
  }

  React.useEffect(() => {
    // This condition will eventually go away, but currently the only use of notifications is the form reviewers feature,
    if (user.role !== 'ANALYST' && flags.isOn(user, 'FORM_REVIEWERS_ENABLED')) {
      count();
    }

    return () => handle.current && clearInterval(handle.current);
  }, []);

  return null;
}

export default NotificationWatcher;